(function () {
	'use strict';

    angular.module("imApp").factory("docArticleEditService", ['$ihttp', function ($ihttp) {
		let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 1376,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 1377,
                    parameters: edit
                });
            },
            deleteItem: function (edit) {
                return $ihttp.post({
                    method: 1378,
                    parameters: edit
                });
            }
		};

		return service;
	}]);
})();
